<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>26th National Chess Championship of the Deaf – 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span>26th National Chess Championship of the Deaf – 2026</span>
            </h2>
        </div>
        <p><strong>Date:</strong> 16th to 20th February 2026</p>
        <p><strong>Venue:</strong> G.H. Raisoni Polytechnic College, Nagpur</p>

        <p>The 26th National Chess Championship of the Deaf was successfully conducted at G.H. Raisoni Polytechnic
            College,
            Nagpur, from 16th to 20th February 2026. The championship was organized under the aegis of the All India
            Sports
            Council of the Deaf (AISCD) and witnessed remarkable participation from across the country.
        </p>
        <hr>
        <h5 class="primary-purple">Dignitaries Present in Inauguration: </h5>

        <ul class="list-style list-style1 mb-3 list-count ">
            <li> Dr. Vivek Kapur, Director, G.H.Raisoni College</li>
            <li> Dr.Akhilesh Ugale ( Registerar) Raisoni Group</li>
            <li> Mr. Bhushan Shriwas, General Secretary, Chess association Nagpur</li>
            <li> Mr. V. Kumar, President, All India Sports Council of the Deaf</li>
            <li> Mr. Rajesh Nair, president, Maharashtra sports council of the Deaf</li>
            <li> Mr. Gopal Birare, General Secretary, Maharashtra sports council of the Deaf</li>
            <li> Mr. Madhav Joshi, Organising Secretary, 26th NCCD. Nagpur</li>
            <li> Mr. Darshan Kshirsagar, Assistant Technical Director-Chess, AISCD</li>
            <li> Mr. M V. Raghavendra, Fide Arbiter</li>
            <li> Mr. Varad Kulkarni, interpreter</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Prize Fund:</h5>
        <ul class="list-style list-style1 mb-3  ">
            <li>Total Prize Fund: ₹1,00,000</li>
            <li>Sponsor: Raisoni Foundation</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Tournament Format: 1st Event</h5>


        <ul class="list-style list-style1 mb-3 list-count ">
            <li>Classical Swiss System</li>
            <li>Open Category: 9 Rounds</li>
            <li>Junior & Sub-Junior Categories: 7 Rounds</li>
            <li>Time Control: 25 minutes + 30 seconds increment per move</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Participation & Categories:</h5>
        <ul class="list-style list-style1 mb-3 list-count ">

            <li>A total of 249 players from 21 states of India competed in three categories:</li>
            <li>Open Category (Above 18 Years) – 152 players</li>
            <li>Junior Category (Under 18 Years) – 56 players</li>
            <li>Sub-Junior Category (Under 16 Years) – 41 players</li>

        </ul>
        <hr>
        <h5 class="primary-purple"> Arbiter Team: </h5>
        <ul class="list-style list-style1 mb-3  ">
            <li> Chief Arbiter: FA Raghavendra M V</li>
            <li>Deputy & Supporting Arbiters:</li>
            <li> FA Amitkumar, Mukesh Tembhurne, NA Ambade Prayas & NA Indurkar Shishir</li>
        </ul>
        <h5 class="primary-purple"> Prize Winners: </h5>
        <div class="row">
            <div class="col">
                <p><strong>Open Men – Top 6 Winners:</strong></p>
                <ul class="  mb-3  ">
                    <li> 1. Watpade Vivek – Maharashtra</li>
                    <li> 2. Alaguraja M.K. – Tamil Nadu</li>
                    <li> 3. Rohit Sharma – Delhi</li>
                    <li> 4. Purushottam Jagannath Aagale – Maharashtra</li>
                    <li> 5. Krishna Reddy Garugu – Andhra Pradesh</li>
                    <li> 6. Vaidya Devendra – Maharashtra</li>
                </ul>
            </div>
            <div class="col">
                <p><strong>Open Women – Top 3 Winners:</strong></p>
                <ul class="  mb-3  ">
                    <li>1. Bimla Sharma – Delhi</li>
                    <li> 2. Malika Handa – Punjab</li>
                    <li> 3. Ambika Masagi – Karnataka</li>
                </ul>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col">
                <p><strong> Junior Boys – Top 3:</strong></p>
                <ul class="  mb-3  ">

                    <li>1. Ankit Ganguly – West Bengal</li>
                    <li>2. Roshan A – Puducherry</li>
                    <li> 3. Kowshik D – Tamil Nadu</li>

                </ul>
            </div>
            <div class="col">
                <p><strong> Junior Girls – Top 3:</strong></p>
                <ul class="  mb-3  ">
                    <li> 1. Shreya Y S – Karnataka</li>
                    <li> 2. Hathila Pinalben – Gujarat</li>
                    <li> 3. Akshara Rahul Tembhare – Maharashtra</li>
                </ul>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col">
                <p><strong> Sub-Junior Boys – Top 3:</strong></p>
                <ul class="  mb-3  ">
                    <li> 1. Sai Akshit Sahoo – Odisha</li>
                    <li> 2. Yashavanth S – Karnataka</li>
                    <li> 3. Govind Jangid – Rajasthan</li>
                </ul>
            </div>
            <div class="col">
                <p><strong> Sub-Junior Girls – Top 3:</strong></p>
                <ul class="  mb-3  ">
                    <li> 1. Konatala Suma Sri – Andhra Pradesh</li>
                    <li> 2. Chavi Singh – Haryana</li>
                    <li> 3. Archita Dehury – Odisha</li>
                </ul>
            </div>
        </div>
        <hr>
        <h5 class="primary-purple"> State Team Recognition
        </h5>
        <div class="row">
            <div class="col">
                <p><strong> Men Team</strong></p>
                <ul class="  mb-3  ">
                    <li> Maharashtra 1
                        st
                    </li>
                    <li> Tamilnadu 2
                        nd
                    </li>
                    <li> Gujrat 3
                        rd
                    </li>
                </ul>
            </div>
            <div class="col">
                <p><strong> Women Team</strong></p>
                <ul class="  mb-3  ">
                    <li> Delhi 1
                        st
                    </li>
                    <li> Gujrat 2
                        nd
                    </li>
                    <li> Rajasthan 3
                        rd</li>
                </ul>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col">
                <p><strong> Junior Boys Team</strong></p>
                <ul class="  mb-3  ">
                    <li>
                        Tamilnadu 1
                        st
                    </li>
                    <li> Gujrat 2
                        nd
                    </li>
                    <li> Kerala 3
                        rd


                    </li>
                </ul>
            </div>
            <div class="col">
                <p><strong> Junior Girls Team</strong></p>
                <ul class="  mb-3  ">
                    <li> Gujrat 1
                        st
                    </li>
                    <li>Karnataka 2
                        nd
                    </li>
                    <li>Kerala 3
                        rd</li>
                </ul>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col">
                <p><strong> Sub Junior Boys Team</strong></p>
                <ul class="  mb-3  ">
                    <li>
                        Odisha 1
                        st
                    </li>
                    <li>Karnataka 2
                        nd
                    </li>
                    <li> Bihar 3
                        rd
                    </li>
                </ul>
            </div>
            <div class="col">
                <p><strong> Sub Junior Girls Team</strong></p>
                <ul class="  mb-3  ">
                    <li> Kerala 1
                        st
                    </li>
                    <li> Odisha 2
                        nd
                    </li>
                    <li> Bihar 3
                        rd</li>
                </ul>
            </div>
        </div>
        <hr>
        <p><strong>Overall Classical Top 3 Teams</strong></p>
        <ul class="  mb-3  ">
            <li>Kerala 1
                st
            </li>
            <li>Odisha 2
                nd
            </li>
            <li>Bihar 3
                rd</li>
        </ul>
        <hr>
        <p><strong>Tournament Format: 2
                nd Event Blitz</strong></p>
        <p>Open to all: 9 Rounds </p>
        <p> Time Control: 03 minutes + 2 seconds increment per move</p>
        <hr>
        <h5 class="primary-purple"> Participation & Categories: </h5>

        <p> A total of 172 players from 21 states of India competed in Open category and top 3 prizes for 6 categories
            Men,
            Women
            above 18 years, junior boys and Girls under 18 Years and Sub Junior Boys & Girls under 16 Years</p>
        <hr>
        <h5 class="primary-purple"> Prize Winners in Blitz: </h5>
        <div class="row row-cols-lg-3 row-cols-sm-2 row-cols-1">
            <!-- Open Men -->
            <div class="col">
                <p><strong>Open Men – Top 3 Winners:</strong></p>
                <ul class="mb-3">
                    <li>1. Rohit Sharma – Delhi</li>
                    <li>2. Vivek Bhaskar Watpade – Maharashtra</li>
                    <li>3. Ashutosh Shukla – Uttar Pradesh</li>
                </ul>
            </div>

            <!-- Open Women -->
            <div class="col">
                <p><strong>Open Women – Top 3 Winners:</strong></p>
                <ul class="mb-3">
                    <li>1. Ambika Masagi – Karnataka</li>
                    <li>2. Malika Handa – Punjab</li>
                    <li>3. Rachna Gupta – Delhi</li>
                </ul>
            </div>

            <!-- Junior Boys -->
            <div class="col">
                <p><strong>Junior Boys – Top 3:</strong></p>
                <ul class="mb-3">
                    <li>1. Ankit Ganguly – West Bengal</li>
                    <li>2. Roshan A – Puducherry</li>
                    <li>3. Abhay – Uttarakhand</li>
                </ul>
            </div>

            <!-- Junior Girls -->
            <div class="col">
                <p><strong>Junior Girls – Top 3:</strong></p>
                <ul class="mb-3">
                    <li>1. Shreya Y S – Karnataka</li>
                    <li>2. Kaviya R – Tamil Nadu</li>
                    <li>3. Sushma M – Karnataka</li>
                </ul>
            </div>

            <!-- Sub-Junior Boys -->
            <div class="col">
                <p><strong>Sub-Junior Boys – Top 3:</strong></p>
                <ul class="mb-3">
                    <li>1. Sai Akshit Sahoo – Odisha</li>
                    <li>2. Rohit – Punjab</li>
                    <li>3. Yashavanth S – Karnataka</li>
                </ul>
            </div>

            <!-- Sub-Junior Girls -->
            <div class="col">
                <p><strong>Sub-Junior Girls – Top 3:</strong></p>
                <ul class="mb-3">
                    <li>1. Kavita Jangid – Rajasthan</li>
                    <li>2. Konatala Suma Sri – Andhra Pradesh</li>
                    <li>3. Dabhi Ekta – Gujarat</li>
                </ul>
            </div>
        </div>
        <hr>

        <h5 class="primary-purple"> Dignitaries Present in Closing Ceremony: </h5>

        <p> Mr. Anup Deshmukh, International Master, Mr. V. Kumar, President, All India Sports Council of the Deaf Mr.
            Rajesh
            Nair, president, Maharashtra sports council of the Deaf, Mr. Gopal Birare, General Secretary, Maharashtra
            sports council
            of the Deaf, Mr. Madhav Joshi, Organising Secretary, 26th NCCD. Nagpur, Mr. Darshan Kshirsagar, Assistant
            Technical Director-Chess, AISCD, Mr. M V. Raghavendra, Fide Arbiter, Mr. Varad Kulkarni, interpreter</p>
        <h5 class="primary-purple"> Conclusion:</h5>
        <p>
            The 26th National Chess Championship of the Deaf was a grand success, showcasing sportsmanship, discipline,
            and
            excellence among deaf chess players across India, the tournament was conducted smoothly in full compliance
            with
            AISCD regulations. The response from players was overwhelming, and the feedback received has been highly
            positive. The Chief Arbiter expresses sincere appreciation for the excellent cooperation extended by the
            organizers, arbiters, and support staff, as well as the commendable fair play spirit displayed by all
            participants.</p>

        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-4.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-4.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-4.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-5.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-5.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-5.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-6.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-6.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-6.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-7.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-7.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-7.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-8.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-8.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-8.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-9.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-9.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-9.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-10.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-10.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-10.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-11.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-11.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-11.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-12.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-12.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-12.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-14.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-14.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-14.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-13.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-13.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-13.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Reports</h4>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/26th-nationals-deaf-cash-prizs-final.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Winner List </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/doc-20260309-WA0002.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Kalpana Prakash </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
